// Reusable Card component
import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@utils/classNames';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass';
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'default', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-xl shadow-lg border',
          {
            'bg-dark-secondary/40 backdrop-blur-sm border-white/5':
              variant === 'default',
            'bg-dark-secondary/30 backdrop-blur-md border-white/10':
              variant === 'glass',
          },
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

